import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import TimeSheet from './index';

const TimeSheetWrapper = props => {
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  return (
    <TimeSheet {...props} printRef={contentRef} handlePrint={handlePrint} />
  );
};

export default TimeSheetWrapper;
